import { useState } from 'react';
import { supportingTypes } from '@/reports/types';
import { styled, Stack, Box, Icons, Button } from '@/theme/index';
import { DateUtil } from '@/utils/index';
import { scrollToElement } from '@/utils/scrollToElement';

const CommentContainer = styled('div')(() => ({
  width: '100%',
  position: 'relative',
}));

const SubCard = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-start',
  justifyContent: 'space-between',

  width: '100%',
  minHeight: '100px',
  borderRadius: '4px',
  border: `solid 2px ${theme.palette.secondary.main}`,
  padding: '20px',
}));

type Props = { comments: supportingTypes.Comments };

const NUM_COMMENTS = 5;
const TARGET_DATE_FORMAT = 'MMMM dd, yyyy';
const SOURCE_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss ZZZ';
const dateParser = new DateUtil();

const CommentCards = ({ comments }: Props) => {
  const [page, setPage] = useState(1);

  const decrementPage = () => {
    setPage(page - 1);
    // Doesn't work quite right for some reason?
    scrollToElement('#comments-section');
  };
  const incrementPage = () => {
    setPage(page + 1);
    // Doesn't work quite right for some reason?
    scrollToElement('#comments-section');
  };

  const filteredComments = comments.slice(
    (page - 1) * NUM_COMMENTS,
    page * NUM_COMMENTS
  );

  return (
    <CommentContainer>
      <Stack spacing={2}>
        {filteredComments.map((comment, index) => {
          const parsedDate = dateParser.parseDateFromString(
            comment.datetime.full,
            TARGET_DATE_FORMAT,
            SOURCE_DATE_FORMAT
          );

          return (
            <SubCard
              spacing={2}
              key={`comment-${index}`}
              data-testid={`comment-card-${index}`}
            >
              <Box>{comment.body}</Box>
              {!comment.name ? (
                <Box>{parsedDate}</Box>
              ) : (
                <Stack spacing={3} direction="row">
                  <Box>{comment.name}</Box>
                  <Box>{parsedDate}</Box>
                </Stack>
              )}
            </SubCard>
          );
        })}
      </Stack>
      {comments.length >= NUM_COMMENTS && (
        <Stack
          padding="10px"
          spacing={2}
          direction="row"
          justifyContent="center"
        >
          <Button
            disabled={page === 1}
            onClick={decrementPage}
            color="success"
            variant="contained"
          >
            <Icons.ArrowBack />
          </Button>
          <Button
            disabled={page === Math.ceil(comments.length / NUM_COMMENTS)}
            onClick={incrementPage}
            color="success"
            variant="contained"
          >
            <Icons.ArrowForward />
          </Button>
        </Stack>
      )}
    </CommentContainer>
  );
};

export default CommentCards;
